import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';
import { environment } from 'src/environments/environment';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-hospital-and-allergies',
  templateUrl: './hospital-and-allergies.component.html',
  styleUrls: ['./hospital-and-allergies.component.scss']
})
export class HospitalAndAllergiesComponent {

  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  CONSTANTS = CONSTANTS
  hospitalAdmissionsForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  years: string[] = []; // Array to hold the list of years
  minYear: number = 1900;
  maxYear: number = new Date().getFullYear();
  isEditable: boolean = true; // Flag to track if the form is editable

  constructor(private toastr: ToastrService, private api: SevaProfileService, private fb: FormBuilder, public genericValidations: GenericValidationsService, private translation: TranslationService) { }

  ngOnInit(): void {
    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
    this.years = this.genericValidations.generateYearRange().map(num => num.toString());;
   
    this.initializeForm();
    this.getApplicantData();
  }
}


ngOnChanges(changes: SimpleChanges): void {
  if (changes['applicantData'] && this.applicantData) {

    this.initializeForm();
    
    // Convert date values to years for the year picker
    const data = { ...this.applicantData };
    if (data.Tetanus) {
      data.Tetanus = new Date(data.Tetanus).getFullYear();
    }
    if (data.Tb) {
      data.Tb = new Date(data.Tb).getFullYear();
    }
    if (data.Polio) {
      data.Polio = new Date(data.Polio).getFullYear();
    }

    this.hospitalAdmissionsForm.patchValue(data);
    this.hospitalAdmissionsForm.disable();
  }
}

  getApplicantData() {
    this.api.apiCall('HospitalAdmissionDetails/GetHospitalAdmissionDetails', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.hospitalAdmissionsForm.disable();
        } else {
          this.hospitalAdmissionsForm.enable();
        }

        // Convert date values to years for the year picker
        if (response.Data.Tetanus) {
          response.Data.Tetanus = new Date(response.Data.Tetanus).getFullYear();
        }
        if (response.Data.Tb) {
          response.Data.Tb = new Date(response.Data.Tb).getFullYear();
        }
        if (response.Data.Polio) {
          response.Data.Polio = new Date(response.Data.Polio).getFullYear();
        }

        this.hospitalAdmissionsForm.patchValue(response.Data);
      }
    })
  }

  initializeForm() {
    this.hospitalAdmissionsForm = this.fb.group({
      IsPastHospitalised: [null, Validators.required],
      HospitalAdmission: ['', Validators.required],
      IsSurgeryDone: [null, Validators.required],
      SurgeryDetails: ['', Validators.required],
      Tetanus: [''],
      Tb: [''],
      Polio: [''],
      OtherImmunizations: [''],
      IsAllergicToMould: [null],
      IsAllergicToPollen: [null],
      IsAllergicToBeeSting: [null],
      MedicineAllergies: [''],
      FoodAllergies: [''],
      OtherAllergies: [''],
      SaveMode: ['', [Validators.required,]],

    });



    const controlMappings = {
      'IsPastHospitalised': ['HospitalAdmission'],
      'IsSurgeryDone': ['SurgeryDetails'],
      
    }


    // Call the service with the isShowOn parameter set to true or false as needed
    this.genericValidations.setupFormListeners(this.hospitalAdmissionsForm, controlMappings, true);

    // Emit the form group to parent component
    this.formGroupChange.emit(this.hospitalAdmissionsForm);


  }



  getTranslation(key: string): string {
    return this.translation.getTranslation(key);
  }

  onSubmit(Mode: number): void {

    // this.hospitalAdmissionsForm.patchValue({
    //   SaveMode: Mode
    // })

    if (!this.hospitalAdmissionsForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;

                  // Add 'submitted' class manually to all invalid controls
    Object.keys(this.hospitalAdmissionsForm.controls).forEach((field) => {
      const control = this.hospitalAdmissionsForm.get(field);
      if (control && control.invalid) {
        control.markAsTouched(); // Ensure ng-touched is triggered
        const element = document.getElementById(field);
        if (element) {
          element.classList.add('submitted'); // Add 'submitted' class to invalid elements
        }
      }
    });

    this.toastr.warning('Please complete all required fields before submitting.');

      return
    }

    const formData = this.hospitalAdmissionsForm.value;

    // Convert year values to Date objects before sending to the backend
    if (formData.Tetanus) {
      formData.Tetanus = new Date(formData.Tetanus, 0, 1); // Convert year to Date object (January 1st of that year)
    }
    if (formData.Tb) {
      formData.Tb = new Date(formData.Tb, 0, 1); // Convert year to Date object (January 1st of that year)
    }
    if (formData.Polio) {
      formData.Polio = new Date(formData.Polio, 0, 1); // Convert year to Date object (January 1st of that year)
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(formData);
    this.addUpdate(cleanedValues, Mode);

  }

  addUpdate(reqBoby: any, Mode: number) {
    reqBoby.SaveMode = Mode;
    this.api.apiCall('HospitalAdmissionDetails/SaveHospitalAdmissionDetail', 'POST', reqBoby).subscribe((response: any) => {
      console.log('POST response:', response);
      this.toastr.success( response?.Message);
      if (Mode ==  this.SaveMode.SAVE) {
        this.nextStep.emit();
      }else if(Mode ==  this.SaveMode.DRAFT){
        this.getApplicantData();
      }
    });
  }


  goToBack() {
    this.previous.emit();
  }

}